import { KINDS, isZone, isLiteral, isRowBreak, zoneCapacity } from '../Formative/dropZones';

export { KINDS, isZone, isLiteral, isRowBreak, zoneCapacity };

export const LOG =
  process.env.NODE_ENV !== 'production'
    ? (...args) => console.log('[BUCKETING]', ...args)
    : () => {};

const NUMBER_ONLY = /^-?\d+(\.\d+)?$/;

export function isNumberOption(option) {
  if (!option || option.imageUrl) return false;
  return NUMBER_ONLY.test((option.text || '').trim());
}

export function groupIntoRows(dropZones) {
  const entries = dropZones || [];
  const rows = [[]];
  for (const entry of entries) {
    if (isRowBreak(entry)) {
      rows.push([]);
      continue;
    }
    rows[rows.length - 1].push(entry);
  }

  const populatedRows = rows.filter((row) => row.length > 0);
  return {
    rows: populatedRows,
    zones: populatedRows.flat().filter(isZone),
  };
}

export function encodePlacements(zones, placements) {
  return JSON.stringify((zones || []).map((zone) => [...((placements || {})[zone.key] || [])]));
}
